<template>
  <router-link
    :to="{
      name: nav.targetRouterName,
      params :{versions:nav.versions}
    }"
    class="nav-link-item"
    :class="{sub}"
  >
    <span @touchstart="report(nav.targetRouterName, nav.name)">
      {{ nav.name }}</span>
    <b
      v-if="tabRedPointInfo.num > 0"
      class="red-point"
      :class="{
        on: tabRedPointInfo.num > 0,
        num: tabRedPointInfo.type === 'number',
      }"
    >{{ tabRedPointInfo.num }}</b>
  </router-link>
</template>

<script>
import { isEmpty } from '@tencent/slug-function';

export default {
  props: {
    // 是否为顶部二级导航
    sub: {
      type: Boolean,
      default: false,
    },
    // 当前nav
    nav: {
      type: Object,
      required: true,
      default: () => ({ targetRouterName: '', name: '' }),
    },
  },
  computed: {
    // 顶部导航 红点
    redPointTopTab() {
      return this.$store.getters.redPointTopTab;
    },
    // 顶部二级导航 红点
    redPointSubTab() {
      return this.$store.getters.redPointSubTab;
    },
    // 根据tab，获取红点信息
    tabRedPointInfo() {
      const { targetRouterName } = this.nav;
      const keyName = this.sub ? 'redPointSubTab' : 'redPointTopTab';
      const defaultRedPointInfo = {
        type: 'general',
        num: 0,
      };
      const currentRedPointInfo = this[keyName][targetRouterName];

      return isEmpty(currentRedPointInfo) ? defaultRedPointInfo : currentRedPointInfo;
    },
  },
  methods: {
    report(ename, cname) {
      PTTSendClick('btn', ename, cname);
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-link-item {
  position: relative;
}
.red-point {
  width: 0.18rem;
  height: 0.18rem;
  border-radius: 50%;
  background-color: #f93501;
  display: none;
  position: absolute;
  right: 0.1rem;
  top: 0.1rem;
  color: transparent;
  font-size: 0.14rem;
  text-align: center;
  line-height: 0.18rem;
}

.red-point.num {
  display: none;
  color: #fff;
}

.red-point.on {
  display: block;
}
</style>
